import { ChangeDetectionStrategy, Component } from '@angular/core';
import { from } from 'rxjs';
import { CompanyService } from 'src/app/services/company.service';
import { SharedDataService } from 'src/app/services/shared-data.service';
import { companiesService } from 'src/app/shared/vive-api/companies.service';

@Component({
  selector: 'app-admin-client-client-registered-vendors',
  templateUrl: './admin-client-client-registered-vendors.component.html',
  styleUrls: ['./admin-client-client-registered-vendors.component.less'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class AdminClientClientRegisteredVendorsComponent {
  constructor(
    private CompanyService: CompanyService,
    private SharedDataService: SharedDataService
  ) {
    this.SharedDataService.listenForEvent<number>().subscribe({
      next: ({ eventName, data }) => {
        if (eventName === 'SetCompanyId' && typeof data === 'number') {
          this.CompanyId = data;

          from(
            companiesService.findOneById({
              pathParams: { companyId: this.CompanyId }
            })
          ).subscribe({
            next: (Company) => {
              const { legalName } = Company;
              this.SharedDataService.sendEvent(
                'SetTitle',
                `Client Registered Vendors - ${legalName}`
              );
            }
          });
        }
      }
    });

    this.SharedDataService.sendEvent('GetCompanyId');
  }

  CompanyId?: number;
  SuppliedQueryData: { [key: string]: any } = {
    ClientRegisteredVendorId: { $ne: null }
  };
}
